import React, { Component } from "react";
import Button from "../../../../components/bases/button/button.js";
import SelectAssets from "../selectassets/selectassets.js";
import { GlobalContext } from "../../../../utils/globalprovider.js";

import ProjectForm from "../projectform/profectform.js";
import UsersList from "../../tables/users/users.js";
import imgClose from "../projectfilters/assets/close.png"
import imgBack from "../projectfilters/assets/back.png"
import imgValider from "../projectfilters/assets/valider.png"
import imgedit from "./assets/edit.png"
import imgdelete from "./assets/delete.png"
import imgvisu from "./assets/visu.png"
import imgassets from "./assets/assets.png"
import imgusers from "./assets/users.png"
import imgselect from "./assets/select.png"

import {apiCreateProjects, apiChangeProjectUser, apiGetProjectsList, apiGetSearchProjects} from "../../../../utils/apis.js"
import {getCurrentUserDatas} from "../../../../utils/software.js"
import { getCurrentProjectDatas } from "../../../../utils/software.js";


import imgorange from "../../../dialogs/assets/status/orange.png"
import imgblue from "../../../dialogs/assets/status/blue.png"
import imgpurple from "../../../dialogs/assets/status/purple.png"
import imggreen from "../../../dialogs/assets/status/green.png"
import imggreen_ok from "../../../dialogs/assets/status/green_ok.png"


import "./projectslist.css"

class ProjectsList extends Component {

  static contextType = GlobalContext;
  constructor(props) {
    super(props);


    var droits = getCurrentUserDatas().droits;

    this.state ={
            displayform:false,
            formulaire: {},
            formaction: "",
            displayUsers: false,
            displayAssets: false,
            pjid:0,
            pjuser: 0,
            pjidselected:-1,
            columms: [],
            liste:[],

            searchFilters: null,

            buttons:
                [
                {type:"text", disabled:false,text:{fr:"Rafraichir",en:"Refresh"},key:"refresh"},
                {type:"text", disabled:((droits & 1) === 1),text:{fr:"Nouveau Projet",en:"New project"},key:"new"},
                //{type:"text", disabled:false,text:{fr:"Refuser",en:"Decline"}, key:"decline"},
                
                
                ]
            }    

    // Liaison des méthodes
    this.title = {fr:"Mes projets",en:"My projects"};
    this.handleButton = this.handleButton.bind(this)
    this.onvalidform = this.onvalidform.bind(this)
    this.onValidFormUsers = this.onValidFormUsers.bind(this)
    this.forceRefreshList = this.forceRefreshList.bind(this)


    this.getListProjectsCallBack = this.getListProjectsCallBack.bind(this)
    
    this.handleEditButton = this.handleEditButton.bind(this)
    this.handleDeleteButton = this.handleDeleteButton.bind(this)
    this.handleAssetsButton = this.handleAssetsButton.bind(this)
    this.handleSelectButton = this.handleSelectButton.bind(this)
    this.handleUsersButton = this.handleUsersButton.bind(this)

  }


  nextProject()
  {

      if ((this.state.pjidselected ) < (this.state.liste.length-1))
      {
        this.GotoProjectId(this.state.liste[this.state.pjidselected+1].pjid);

        
        this.setState({pjidselected: this.state.pjidselected+1});
      }
  }
  previousProject()
  {
    if ((this.state.pjidselected ) >0 )
    {
        this.GotoProjectId(this.state.liste[this.state.pjidselected-1].pjid);
        this.setState({pjidselected: this.state.pjidselected - 1});
    }

  }


  selectProject()
  {


    if ((this.state.pjidselected >=0 ) && (this.state.pjidselected ) < (this.state.liste.length))
      this.props.onSelectProject( this.state.liste[this.state.pjidselected].pjid)
  }

  setDatasSearchDatas(datas)
  {

      

      var userid = getCurrentUserDatas().id;

      var apisearch = {
        
        pjid:0,
        pjuser: datas.allusers?0:userid,
        pjorititle:datas.title,
        pjsherlock:datas.sherlock,
        pjisan: datas.isan,
        pjem:datas.em,
        pjserie:datas.serie,
        pjclient:datas.client,
        pjdiffusor:datas.diffusor,
        pjseason:datas.season,
        pjepisode:datas.episode,
        pjcreatedate:datas.createdate,
        pjdeliverydate:datas.deliverydate,
        
        pjorilang:datas.langori,
        pjstatus:datas.status,

        order:datas.order,
    }

    

    this.setState({searchFilters: apisearch});
    apiGetSearchProjects(apisearch, this.getListProjectsCallBack)


  }



  componentDidMount()
  {
    
    
    var txtname = this.context.language=="fr"?"Nom":"Name";
    var txtpicture = this.context.language=="fr"?"Image":"Picture";

    var columms = [
      {width:3,text:"Id",  zone: "pjid", type:"text", align:"center"},
      {width:3,text:this.context.language=="fr"?"Etat":"State",  zone: "pjstatus", type:"state", align:"center"},
      {width:17,text:this.context.language=="fr"?"Titre original":"Original title", zone: "pjorititle", type:"text", align:"left"},
      {width:9,text:this.context.language=="fr"?"Sherlock":"Sherlock", zone: "pjsherlock", type:"text", align:"center"},
      {width:17,text:this.context.language=="fr"?"Série":"Serie", zone: "pjserie", type:"table", align:"left"},
      {width:16,text:this.context.language=="fr"?"Client":"Client", zone: "pjclient", type:"table", align:"left"},
      {width:7,text:this.context.language=="fr"?"Livraison":"Delivery Date", zone: "pjdeliverydate", type:"date", align:"center"},
      {width:7,text:this.context.language=="fr"?"Création":"Create Date", zone: "pjcreatedate", type:"date", align:"center"},
      {width:4,text:this.context.language=="fr"?"Saison":"Season", zone: "pjseason", type:"text", align:"center"},
      {width:4,text:this.context.language=="fr"?"Ep.":"Ep.", zone: "pjepisode", type:"text", align:"center"},


      {width:13, text:"Actions",  zone: "action", type:"actions", align:"center"}
    ]
    this.setState({columms: columms})
    
    if (this.state.searchFilters != null)
      apiGetProjectsList(this.getListProjectsCallBack)

    



  }

  GotoProjectId (pjid)
  {
    const row = document.getElementById("project"+pjid);
    if (row)
    {
        
        row.scrollIntoView({
          behavior: "smooth",   // animation douce (optionnel)
          block: "center",     // évite de scroller toute la page
          inline: "nearest"
        });      
    }

  }

  componentDidUpdate()
  {
      if (this.props.pjidselected != -1) this.GotoProjectId(this.props.pjidcurrent);
  }


  getListProjectsCallBack(datas)
  {

    var newselected = this.state.pjidselected;
    
    if (this.state.pjidselected >= datas.length)
      newselected = datas.length - 1;


    if (newselected === -1)
    {
      // on recherche le projet
      for (var p=0; p < datas.length; p++)
      {
        if (datas[p].pjid === this.props.pjidcurrent)
          newselected = p;
      }
    }
    
    this.setState({liste: datas, pjidselected: newselected})
  }

  handleSelectButton(datas)
  {
      this.props.onSelectProject( datas.pjid)
      
  }

  handleUsersButton(datas)
  {
    console.log("click user ", datas.pjuser)

    this.setState({
      displayUsers: true,
      pjid: datas.pjid,
      pjuser: datas.pjuser,
    })
    if (this.props.ondisablekeyboard) this.props.ondisablekeyboard(true);
  }


  handleEditButton(datas)
  {

    var droits = getCurrentUserDatas().droits;
    var action="edit";
    if ((droits & 4) === 0)
    {
      if ((droits & 1) === 1) action="view";
      if (datas.pjsherlock.trim() !=="") action="view";
    }


      this.setState({
        formulaire: datas,
        formaction: action,
        displayform: true,
      })
      if (this.props.ondisablekeyboard) this.props.ondisablekeyboard(true);
} 
  handleDeleteButton(datas)
  {
    this.setState({
      formulaire: datas,
      formaction: "delete",
      displayform: true,
    })
    
    if (this.props.ondisablekeyboard) this.props.ondisablekeyboard(true);

  }
  handleAssetsButton(datas)
  {
    
    this.setState({
      formulaire: datas,
      displayAssets: true,
    })
    if (this.props.ondisablekeyboard) this.props.ondisablekeyboard(true);

  }


  handleButton(datas)
  {

      switch (datas)
      {
          case "new":
            
            this.setState({
              formulaire: {},
              formaction: "add",
              displayform: true,
            }
            
            )
            if (this.props.ondisablekeyboard) this.props.ondisablekeyboard(true);
            break;
          
          case "refresh":
            if (this.state.searchFilters != null)
              apiGetSearchProjects(this.state.searchFilters, this.getListProjectsCallBack)
            break;
      }

  }


  onValidFormUsers(datas)
  {
    console.log("retour valid form user", datas)
    this.setState({displayUsers: false})
    if (this.props.ondisablekeyboard) this.props.ondisablekeyboard(false);
    if (datas.ret)
    {
       var datas =
       {
        pjid: this.state.pjid,
        pjuser: datas.id,
       }
       apiChangeProjectUser(datas,this.forceRefreshList)

    }
  }

  forceRefreshList()
  {
    if (this.state.searchFilters != null)
      apiGetSearchProjects(this.state.searchFilters, this.getListProjectsCallBack)


  }

  onvalidform(datas)
  {
    console.log("ON VALID FORM PROJET", datas, this.state.formaction)

    if (this.state.formaction === "add")
    {
      if (("ok" in datas) && (datas.ok))
      {
        this.props.onSelectProject(datas.id);
      }
    }

    if (this.state.formaction === "delete")
    {
      if (("ok" in datas) && (datas.ok))
      {
        this.props.onCheckSelectProjet(datas.id);
      }
    }
  


    this.setState({
      formulaire: {},
      formaction: "",
      displayform: false,
      displayAssets: false,
    })
    if (this.props.ondisablekeyboard) this.props.ondisablekeyboard(false);



    if (this.state.searchFilters != null)
      apiGetSearchProjects(this.state.searchFilters, this.getListProjectsCallBack)

  }


  onQuit()
  {
    
  }
  


  setDisabledButtonByType(type, value)
  {
      var buttons = this.state.buttons;
      var nb = buttons.length;
      for (var i=0; i < nb ; i++)
      {
        if (buttons[i].type == type)
        {
          if (buttons[i].disabled != value)
          {
            buttons[i].disabled = value;
            this.setState({buttons:buttons});
          }
          break;
        }
      }
      
  }

  setDisabledButtonByKey(key, value)
  {
      var buttons = this.state.buttons;
      var nb = buttons.length;
      for (var i=0; i < nb ; i++)
      {
        if (buttons[i].key == key)
        {
          if (buttons[i].disabled != value)
          {
            buttons[i].disabled = value;
            this.setState({buttons:buttons});
          }
          break;
        }
      }
      
  }

  
  
  render(body) {
   
    
    if (!this.props.display) return (<></>)

       

      var localrender = []
      if (this.state.displayform)
      {
          localrender.push(
                  <>
                    <ProjectForm
                        zindex = {2}
                        display = {this.state.displayform}
                        startposition = "center"
                        closeButton = {true}
                        onvalidform = {this.onvalidform}
                        formulaire = {this.state.formulaire}
                        action = {this.state.formaction} />
                  </>
                );
  
      }

      if (this.state.displayAssets)
        {

            localrender.push(
                    <>
                      <SelectAssets
                          zindex = {2}
                          display = {this.state.displayAssets}
                          startposition = "center"
                          closeButton = {true}
                          onvalidform = {this.onvalidform}
                          pjid = {this.state.formulaire.pjid}
                           />
                    </>
                  );
    
        }
  

      if (this.state.displayUsers)
      {
        localrender.push(
            <UsersList 
            onvalidform={this.onValidFormUsers} 
            closebutton = {true} zindex={1} 
            display = {true} select={true} 
            project={this.state.pjid}
            pjuser={this.state.pjuser}
            />
        )
      }
      var n=0;
      var listelement = [];

      


      for (var i=0; i < this.state.liste.length; i++)
      {

        var backcolor = "transparent";
        if (n & 1)
          backcolor = "#080808";
        if (this.state.liste[i].pjid === this.props.pjidcurrent)
          backcolor = "#202080";

        var style = {backgroundColor: backcolor};
        if (i == this.state.pjidselected)
          style = {backgroundColor: backcolor, outline:"2px solid gray", borderRadius:"5px"};

        
  
        listelement.push(
            <tr style={style} id={"project"+this.state.liste[i].pjid}>
            <ListProjectsElement
            onedit = {this.handleEditButton}
            ondelete = {this.handleDeleteButton}
            onassets = {this.handleAssetsButton}
            onselect = {this.handleSelectButton}
            onusers = {this.handleUsersButton}
            
            index={i} columms = {this.state.columms} values = {this.state.liste[i]} />  
            </tr>
          )
        n=n+1;
      }
  

    // on calcul les boutons
    var buttons = [];
    for (var i=0; i < this.state.buttons.length; i++)
    {
      switch (this.state.buttons[i].type)
      {

        case "text":

          

          buttons.push(
            <Button 
            button={true}
            text={this.state.buttons[i].text}
            tooltip={null}
            disable={this.state.buttons[i].disabled}
            datas={this.state.buttons[i].key}
            onClick={this.handleButton}
            height={20}/>
            
          )
          buttons.push(<span>&nbsp;&nbsp;</span>);
          break;

        case "back":
          buttons.push(
            <Button 
            button={true}
            image={imgBack} 
            tooltip={{fr:"Abandonner",en:"Cancel"}} 
            disable={this.state.buttons[i].disabled}
            datas="back"
            onClick={this.handleButton}
            width={20} height={20}/>
            
          )
          buttons.push(<span>&nbsp;&nbsp;</span>);
          
          break;
        case "ok":
          buttons.push(
            <Button 
            button={true}
            image={imgValider}
            tooltip={{fr:"Valider la page",en:"Submit"}} 
            disable={this.state.buttons[i].disabled}
            datas="ok"
            onClick={this.handleButton}
            width={20} height={20}/>
            
          )
          buttons.push(<span>&nbsp;&nbsp;</span>);
          
        }
    }


    var maxheight =  (window.innerHeight * 65)/100;
    if (maxheight > 800) maxheight = 800;

    return (
      <>
      {localrender}
        <div className="projectsListInterneDiv" id="innerDivPL">

          <div className="projectsListTitleText">
          {this.context.language=="fr"?this.title.fr:this.title.en}
          </div>
          <div className="projectslist-container-header">
            <table  cellSpacing={5} cellPadding={0} width="100%">
                <ListProjectsHeader columms = {this.state.columms} />          
            </table>
          </div>
          <div className="projectslist-container">
            <table cellSpacing={5} cellPadding={0} width="100%">
                
                  {listelement}
            </table>      
          </div>
          {body}
          <div className="projectsListButtonsDiv">
            {buttons}
          </div>

        </div>
      </>
    )
    /*
        return (
      <>
      {localrender}

      <div id="fullDiv" className="projectsListFullDiv"></div>
        <div className="projectsListInterneDiv" id="innerDivPL"
         
        >
        <div className="projectsListTitle"
        onMouseDown={this.handleMouseDown}>
          <div className="projectsListTitleText">
          {this.context.language=="fr"?this.title.fr:this.title.en}
          </div>
          </div>
          <div className="projectslist-limit" style={{width:"100%", height:maxheight}}>

            <div className="projectslist-container-header">
            <table className="projectslist-projectsList" cellSpacing={5} cellPadding={0}>
                <ListProjectsHeader columms = {this.state.columms} />          
            </table>
            </div>
            <div className="projectslist-container">
            <table className="projectslist-projectsList" cellSpacing={5} cellPadding={0}>
                
                  {listelement}
            </table>      
            </div>
            


        </div>

      {body}
      <div className="projectsListButtonsDiv">
         {buttons}
      </div>
      </div>
      </>
    );
    */
  }
}


ProjectsList.defaultProps =
{
    display: true,
}


//  ****************************************************************************************
//  ListProjectsHeader
//  ****************************************************************************************
class ListProjectsHeader extends React.Component{
    constructor(props)
    {
        super(props);
    }

    createAllHeaderColumms()
    {
        var retour = []
        var styleh = "projectslist-headerList"
        for (var i=0; i<this.props.columms.length; i++)
        {
            var width = this.props.columms[i].width + "%"
            var key="userheader" + i;
          retour.push(
              
              <td width={width} className={styleh} key={key}>
              
                  {this.props.columms[i].text}
              </td>)
        }
        return ( retour)
    }


  render()
  {
      return (
          <>
                  {this.createAllHeaderColumms()}
          </>
      )
  }

}

//  ****************************************************************************************
//  ListProjectElement
//  ****************************************************************************************
class ListProjectsElement extends React.Component{
  static contextType = GlobalContext;
  constructor(props)
  {
      super(props);
  }

  onClickElement(datas)
  {
    this.props.onselect(datas);
  }


  createAllElementColumms()
  {
      var retour = []
      var styleh = "projectslist-elementList"
      for (var i=0; i<this.props.columms.length; i++)
      {
          var width = this.props.columms[i].width + "%"
          var key="userelement" + i;


        var style = {height:"32px", textAlign: this.props.columms[i].align, paddingLeft:"3px", borderRadius:"4px"};
        switch (this.props.columms[i].type)
        {
          case "text":

            if (this.props.columms[i].zone === "pjid")

              retour.push(
                <td onClick={(e)=>{this.onClickElement(this.props.values)}} width={width} className={styleh} key={key} style={style}>
                
                    {this.props.values["pjid"]}
                    &nbsp;
                    {this.props.values["pjuser"]}
                    
                </td>)
            
            else

              retour.push(
                  
                  <td onClick={(e)=>{this.onClickElement(this.props.values)}} width={width} className={styleh} key={key} style={style}>
                  
                      {this.props.values[this.props.columms[i].zone]}
                  </td>)
            break;

            case "date":
              var date = this.props.values[this.props.columms[i].zone];
              if (date.length != 10)
                date = "**/**/****";
              else
                date = date.substr(8,2)+ "/"+ date.substr(5,2)+"/"+ date.substr(0,4);
              retour.push(
                  
                  <td onClick={(e)=>{this.onClickElement(this.props.values)}} width={width} className={styleh} key={key} style={style}>
                      {date}
                  </td>)
                break;
  
            case "state":
              var img = imgorange;
              switch(this.props.values[this.props.columms[i].zone])
              {
                case 2: img = imgblue; break;
                case 3: img = imgpurple; break;
                case 4: img = imggreen; break;
                case 5: img = imggreen_ok; break;

              }
              retour.push(<td onClick={(e)=>{this.onClickElement(this.props.values)}} width={width} className={styleh} key={key} style={style}>
                <img height="32" src={img}/>
                  </td>);
            break;


            case "image":
              if (this.props.values[this.props.columms[i].zone] =="")
                retour.push(<td width={width} className={styleh} key={key} style={style}>&nbsp;</td>);
              else
              retour.push(<td width={width} className={styleh} key={key} style={style}>
                  <img height="32" src={this.props.values[this.props.columms[i].zone]}/>
                    </td>);
              break;

             case "table":
              var index = this.props.values[this.props.columms[i].zone];
              var image="";
              var lib="";

             

      
              var feminin="";
              switch (this.props.columms[i].zone)
              {
                  case "pjserie":
                    lib = this.props.values["sename"];
                    image = this.props.values["seimage"];
                    feminin="e";
                    break;
                  case "pjclient":
                    lib = this.props.values["clname"];
                    image = this.props.values["climage"];
                    break;
              }

              var table = (<></>)
              if (index < 1)
                table = (<>{this.context.language=="fr"?"Non Précisé"+feminin+".":"Not Set"}</>)
              else
              {
                if (lib == null)
                  table = (<>{this.context.language=="fr"?"Non Retrouvé"+feminin+".":"Unknown"}</>)
                else
                {
                  if (image == null)
                    table = (<>{lib}</>)
                  else
                    
                    table = (
                      <>
                        
                        <img height="28" src={image} style={{verticalAlign:"middle"}}/>
                          &nbsp;{lib}

                        </>
                    )
                }
              }

              retour.push(
              <td onClick={(e)=>{this.onClickElement(this.props.values)}} width={width} className={styleh} key={key} style={style}>
              {table}
              </td>)


              
              break;

          case "actions":


            var droits = getCurrentUserDatas().droits;

            var edittext = {fr:"Modifier",en:"Edit"}
            var editimg = imgedit;

            if ((droits & 4) === 0)
            {
              if (
                (( droits & 1) != 0) || (this.props.values["pjsherlock"].trim() !==""))
  
              {
                edittext = {fr:"Visualiser",en:"View"}
                editimg = imgvisu;
              }
  
            }


            var users = (<></>)
            if ((droits & 4) !== 0)
              users =(
                  <>
                  &nbsp;
                  
                  <Button 
                  button={true}
                  image={imgusers}
                  tooltip= {{fr:"Changer d'utilisateur",en:"Change user."}}
                  disable={false}
                  datas={this.props.values}
                  onClick={this.props.onusers}
                  width={20} height={20}/>
                  </>
              )
            

            retour.push(
                
              <td width={width} className={styleh} key={key} style={style}>

                <Button 
                button={true}
                image={editimg}
                tooltip={edittext} 
                disable={false}
                datas={this.props.values}
                onClick={this.props.onedit}
                width={20} height={20}/>

                &nbsp;

                <Button 
                button={true}
                image={imgdelete}
                tooltip={{fr:"Supprimer",en:"Delete"}} 
                disable={false}
                datas={this.props.values}
                onClick={this.props.ondelete}
                width={20} height={20}/>

                &nbsp;

                <Button 
                button={true}
                image={imgassets}
                tooltip={{fr:"Assets...",en:"Assets.."}} 
                disable={false}
                datas={this.props.values}
                onClick={this.props.onassets}
                width={20} height={20}/>

                &nbsp;


                {users}
              </td>)
            break;
            
        }
      }
      return ( retour)
  }


render()
{
    return (
        <>
                {this.createAllElementColumms()}
        </>
    )
}

}


export default ProjectsList;
